// @flow
import { COMPONENTS_TYPEAHEAD_NAME, COMPONENTS_TYPEAHEAD_ENTITIES } from './typeahead';
import { COMPONENTS_DATE_PERIOD_ENTITIES, COMPONENTS_DATE_PERIOD_NAME } from './date-period';
import { COMPONENTS_ADDRESS_EDITOR_ENTITIES } from 'rgs-nfd-ui-kit/ko-components/address-editor';
import { COMPONENTS_TREE_ENTITIES, COMPONENTS_TREE_NAME } from 'rgs-nfd-ui-kit/ko-components/tree';
import { COMPONENTS_TREE_LIST_ENTITIES, COMPONENTS_TREE_LIST_NAME } from './tree-list';
import {
	COMPONENTS_BTN_ENTITIES,
	COMPONENTS_BTN_GOLD_NAME,
	COMPONENTS_BTN_RED_NAME,
	COMPONENTS_BTN_SUITCASE_NAME,
} from 'rgs-nfd-ui-kit/ko-components/button';
import {
	COMPONENTS_SWITCHER_DOUBLE_ENTITIES,
	COMPONENTS_SWITCHER_DOUBLE_NAME,
} from './switcher-double';
import {
	COMPONENTS_DROPDOWN_ENTITIES,
	COMPONENTS_DROPDOWN_GROUP_LIST_NAME,
	COMPONENTS_DROPDOWN_LIST_NAME,
	COMPONENTS_DROPDOWN_NAME,
	COMPONENTS_DROPDOWN_TYPEAHEAD_NAME,
} from 'rgs-nfd-ui-kit/ko-components/dropdown';
import { COMPONENTS_FIO_INPUT_ENTITIES, COMPONENTS_FIO_INPUT_NAME } from './fio-input';
import {
	COMPONENTS_TYPEAHEAD_FIO_INPUT_ENTITIES,
	COMPONENTS_TYPEAHEAD_FIO_INPUT_NAME,
} from './typeahead-fio-input';
import { COMPONENTS_CHECKBOX_ENTITIES, COMPONENTS_CHECKBOX_NAME } from './checkbox';
import { COMPONENTS_LIST_ENTITIES, COMPONENTS_LIST_NAME } from './list';
import {
	COMPONENTS_SWITCHERS_ENTITIES,
	COMPONENTS_SWITCHERS_NAME,
} from 'rgs-nfd-ui-kit/ko-components/switchers';
import {
	COMPONENTS_UPLOAD_FILE_ENTITIES,
	COMPONENTS_UPLOAD_FILE_NAME,
} from 'rgs-nfd-ui-kit/ko-components/upload-file';
import { COMPONENTS_SELECT_ENTITIES } from 'rgs-nfd-ui-kit/ko-components/select';
// alerts
import { WarningAlertKoComponent, WarningAlertKoComponentHtml } from './alerts';
import { COMPONENTS_RADIO_ENTITIES } from 'rgs-nfd-ui-kit/ko-components/input-radio';
import {
	COMPONENTS_LOADER_ENTITIES,
	COMPONENTS_LOADER_NAME,
} from 'rgs-nfd-ui-kit/ko-components/loader';
import {
	COMPONENTS_CHECKBOX_SLIDER_NAME,
	COMPONENTS_CHECKBOX_SLIDER_ENTITIES,
} from 'rgs-nfd-ui-kit/ko-components/checkbox-slider';
import {
	COMPONENTS_MENU_LIST_NAME,
	COMPONENTS_MENU_LIST_ENTITIES,
} from 'rgs-nfd-ui-kit/ko-components/menu-list';

const COMPONENTS_WARNING_ALERT_NAME = 'warning-alert';
const COMPONENTS_WARNING_ALERT_ENTITIES = [
	{
		name: COMPONENTS_WARNING_ALERT_NAME,
		entity: WarningAlertKoComponent,
		template: WarningAlertKoComponentHtml,
	},
];

//names

const entities = [
	...COMPONENTS_DATE_PERIOD_ENTITIES,
	...COMPONENTS_ADDRESS_EDITOR_ENTITIES,
	...COMPONENTS_TREE_ENTITIES,
	...COMPONENTS_TREE_LIST_ENTITIES,
	...COMPONENTS_BTN_ENTITIES,
	...COMPONENTS_SWITCHER_DOUBLE_ENTITIES,
	...COMPONENTS_DROPDOWN_ENTITIES,
	...COMPONENTS_FIO_INPUT_ENTITIES,
	...COMPONENTS_TYPEAHEAD_FIO_INPUT_ENTITIES,
	...COMPONENTS_CHECKBOX_ENTITIES,
	...COMPONENTS_LIST_ENTITIES,
	...COMPONENTS_TYPEAHEAD_ENTITIES,
	...COMPONENTS_SWITCHERS_ENTITIES,
	...COMPONENTS_UPLOAD_FILE_ENTITIES,
	...COMPONENTS_SELECT_ENTITIES,
	...COMPONENTS_WARNING_ALERT_ENTITIES,
	...COMPONENTS_RADIO_ENTITIES,
	...COMPONENTS_LOADER_ENTITIES,
	...COMPONENTS_CHECKBOX_SLIDER_ENTITIES,
	...COMPONENTS_MENU_LIST_ENTITIES,
];

const components = entities.reduce((prev, { name, entity, template }) => ({
	...prev, [name]: {
		viewModel: entity,
		template,
	},
}), {});

const TYPES = {
	DATE_PERIOD: COMPONENTS_DATE_PERIOD_NAME,
	TREE: COMPONENTS_TREE_NAME,
	TREE_LIST: COMPONENTS_TREE_LIST_NAME,

	DROPDOWN: COMPONENTS_DROPDOWN_NAME,
	DROPDOWN_LIST: COMPONENTS_DROPDOWN_LIST_NAME,
	DROPDOWN_TYPEAHEAD: COMPONENTS_DROPDOWN_TYPEAHEAD_NAME,
	DROPDOWN_GROUP_LIST: COMPONENTS_DROPDOWN_GROUP_LIST_NAME,

	BTN_GOLD: COMPONENTS_BTN_GOLD_NAME,
	BTN_RED: COMPONENTS_BTN_RED_NAME,
	BTN_SUITCASE: COMPONENTS_BTN_SUITCASE_NAME,

	SWITCHER_DOUBLE: COMPONENTS_SWITCHER_DOUBLE_NAME,
	TYPEAHEAD: COMPONENTS_TYPEAHEAD_NAME,
	SWITCHERS: COMPONENTS_SWITCHERS_NAME,
	CHECKBOX: COMPONENTS_CHECKBOX_NAME,
	LIST: COMPONENTS_LIST_NAME,
	FIO_INPUT: COMPONENTS_FIO_INPUT_NAME,
	TYPEAHEAD_FIO_INPUT: COMPONENTS_TYPEAHEAD_FIO_INPUT_NAME,
	UPLOAD_FILE: COMPONENTS_UPLOAD_FILE_NAME,
	WARNING_ALERT: COMPONENTS_WARNING_ALERT_NAME,
	LOADER: COMPONENTS_LOADER_NAME,
	CHECKBOX_SLIDER: COMPONENTS_CHECKBOX_SLIDER_NAME,
	MENU_LIST: COMPONENTS_MENU_LIST_NAME,
};

//exporting only at one point
export {
	TYPES,
	components,
};
